// extracted by mini-css-extract-plugin
module.exports = {"SContentWrapper":"ContentWrapper_SContentWrapper__tlbAL","noBgColor":"ContentWrapper_noBgColor__EFdJj"};